export type { ProfileResumeBuilderV2Props, ProfileResumeTabV2 } from "./ProfileResumeBuilderV2";
export { ProfileResumeBuilderV2 } from "./ProfileResumeBuilderV2";
